<template>
  <v-container>
    <v-layout
      row
      wrap
      justify-center
    >
      <v-flex
        xs12
        sm8
        md6
        lg6
      >
        <v-card
          class="mt-3 transparent"
          :class="{
          'elevation-8 pt-3 pb-4': $vuetify.breakpoint.mdAndUp,
          'elevation-0': $vuetify.breakpoint.smAndDown
        }"
        >
          <div :class="{'px-4': $vuetify.breakpoint.smAndUp}">
            <div class="subheading">{{$t('labels.yield')}}</div>
            <div class="caption grey--text text--darken-1">
              {{$t('labels.sinceDelivery')}}: {{contractDate}}
            </div>

<!--            <v-alert-->
<!--              value="true"-->
<!--              type="info"-->
<!--              outline-->
<!--            >-->
<!--              {{$t('messages.disturbanceMessage.text')}}-->
<!--            </v-alert>-->

              <v-alert
              v-if="yields.overview.yesterday === null"
              value="true"
              type="info"
              dismissible
              >
                {{$t('messages.zeroYieldMessage.text')}}
              </v-alert>


            <div class="yield-today pl-3">
              <span
                class="yield-today__value"
                v-if="!yields.overview.isFetching"
              >
                {{round(yields.overview.forever)}} <small class="yield-today__unit">{{unit}}</small>
              </span>
              <span
                class="yield-today__value"
                v-else
              >
                <v-icon
                  large
                  :color="tick ? 'black' : 'primary'"
                  style="transition-duration: 2000ms !important"
                >fa-solar-panel</v-icon>
              </span>
            </div>
            <yields-timeline
              :yields="yields.overview"
              :view="view"
              :is-fetching="yields.overview.isFetching"
            />
          </div>

        </v-card>
      </v-flex>

      <v-flex
        xs12
        sm12
        md6
        lg6
        v-if="$vuetify.breakpoint.mdAndUp"
        class="pl-5"
      >
        <yearly-yields-panel
          :years="years"
          :view="view"
        />
      </v-flex>

      <v-flex
        xs12
        sm12
        md6
        lg6
        v-if="$vuetify.breakpoint.smAndDown"
        class="pt-0"
      >
        <yearly-yields-list
          :years="years"
          :view="view"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment';

import YieldsTimeline from '@/components/YieldsTimeline.vue';
import YearlyYieldsPanel from '@/components/YearlyYieldsPanel.vue';
import YearlyYieldsList from '@/components/YearlyYieldsList.vue';

import { round } from '@/helpers/yields';

export default {
  components: {
    YearlyYieldsPanel,
    YearlyYieldsList,
    YieldsTimeline,
  },

  data() {
    return {
      tick: false,
      view: 'yield',
    };
  },

  async created() {
    const id = setInterval(() => { this.tick = !this.tick; }, 1000);

    await this.$store.dispatch('yields/getAllYears');

    clearInterval(id);
  },

  computed: {
    unit() { return this.view === 'yield' ? 'kWh' : 'EUR'; },

    yields() { return this.$store.state.yields; },

    years() {
      return this.$store.state.yields.yields;
    },

    contractDate() {
      if (this.yields.overview.isFetching || !this.yields.overview.firstYieldDate) return 'Onbekend';

      return moment(this.yields.overview.firstYieldDate, 'Y-MM-DD').format('DD-MM-YYYY');
    },

    round() { return round; },
  },
};
</script>

<style lang="scss" scoped>
.display-1 {
  position: relative;
}

.switch-view {
  position: absolute;
  top: 0;
  right: 0;
}

.layout .yield-table.flex {
  padding-top: 0;
}

@media (min-width: 960px) {
  .layout .yield-table.flex {
    padding: 0 32px;
  }
}
</style>


<style lang="scss">
.timeline__terminator {
  .v-icon {
    font-size: 24px;
  }
}

.month-yield {
  font-size: 16px;

  &__unit {
    margin-left: 4px;
    font-weight: 300;
    color: rgba(#000, 0.5);
  }
}

.yield {
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-weight: bold;

  &__unit {
    margin-left: 4px;
    color: rgba(#000, 0.5);
    font-size: 14px;
    font-weight: 300;
  }
}

.yield-today {
  margin-top: 16px;
  border-radius: 100%;
  width: 150px;
  height: 150px;
  background-color: white;
  border: 8px solid #eca93d;
  box-shadow: 0 0 8px rgba(#000, 0.25);
  position: relative;
  left: 50%;
  transform: translateX(-50%);

  &__title {
    position: absolute;
    width: 100%;
    top: 15px;
    text-align: center;
  }

  &__value {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 32px;
    font-weight: bold;
  }

  &__unit {
    display: block;
    margin-top: -8px;
    font-size: 16px;
    color: rgba(#000, 0.5);
    font-weight: 300;
  }
}

.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>
